import { Link } from "react-router-dom";
import ReturnsSection from "./landing/ReturnsSection";

export default function Returns() {
  return (
    <div className="min-h-screen landing-bg flex flex-col" data-testid="returns-page">
      <header className="border-b border-[#24272B] sticky top-0 z-20" style={{ background: "#0E1012" }}>
        <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 w-fit" data-testid="returns-home-link">
            <span className="solera-symbol" />
            <span className="wordmark text-bone text-sm">Solera Ventures</span>
            <span className="t-cap text-muted-s ml-2 hidden sm:inline fig">solera.vc</span>
          </Link>
          <Link to="/login" className="btn-ghost !py-2 !px-5" data-testid="returns-login-link">Login</Link>
        </div>
      </header>
      <main className="flex-1 max-w-6xl w-full mx-auto px-6">
        <ReturnsSection />
      </main>
    </div>
  );
}
